import Vue from 'vue'
import {
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Input,
  Loading,
  Message,
  Option,
  Pagination,
  Popover,
  Select
} from 'element-ui'

Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Input)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(Select)
Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message
